import { styled } from "@mui/material";
import { editorName } from "../classes.js";
const EditorContent = styled("div", {
  name: editorName,
  slot: "EditorContent",
  overridesResolver: (_, styles) => styles.editorContent
})(({ theme, ownerState }) => ({
  width: "100%",
  height: "100%",
  border: `1px solid ${(theme.vars ?? theme).palette.divider}`,
  display: "flex",
  overflow: "hidden",
  borderRadius: (theme.vars ?? theme).shape.borderRadius,
  flexDirection: "column",
  backgroundColor: (theme.vars ?? theme).palette.background.paper,
  ...ownerState?.error && {
    borderColor: (theme.vars ?? theme).palette.error.main
  }
}));
export {
  EditorContent
};
//# sourceMappingURL=EditorContent.js.map
